// No nested objects
const formatParameters = (prms) => {
  Object.entries(prms).forEach(([key, value]) => {
    prms[key] = [value];
  });
};

export const logEvent = (event, parameters = {}) => {
  formatParameters(parameters);
  if (window.mybank_settings.mode !== "production") {
    console.log(event, parameters);
  }
  const jsonEvent = JSON.stringify({
    event,
    parameters,
  });
  if (window.mobapp && window.mobapp.logAnalyticEvent != null) {
    window.mobapp.logAnalyticEvent(jsonEvent);
  }

  return true;
};
